import React, { useState } from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, ArrowLeft, Upload } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Link, useNavigate } from 'react-router-dom';
import { MessageModal } from '../../components/modals/MessageModal';
export function CreatePublicListingPage() {
  const navigate = useNavigate();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    plotNumber: '',
    surveyNumber: '',
    location: '',
    area: '',
    zoning: '',
    basePrice: '',
    description: ''
  });
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSuccessModalOpen(true);
  };
  const handleModalClose = () => {
    setIsSuccessModalOpen(false);
    navigate('/authority/listings');
  };
  return <DashboardLayout title="Public Listings" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2664">
      <div className="max-w-4xl mx-auto" data-id="element-2665">
        <Link to="/authority/listings" className="flex items-center gap-2 text-sm text-gray-500 hover:text-[#1f2933] mb-6" data-id="element-2666">
          <ArrowLeft className="w-4 h-4" data-id="element-2667" /> Cancel & Back
        </Link>

        <h1 className="text-2xl font-bold mb-2" data-id="element-2668">Create Public Land Listing</h1>
        <p className="text-gray-500 font-mono text-sm mb-8" data-id="element-2669">
          Add government land parcel to public inventory for future auctions
        </p>

        <form onSubmit={handleSubmit} className="bg-white border border-gray-300 p-8 space-y-8" data-id="element-2670">
          <section data-id="element-2671">
            <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-2672">
              Land Parcel Details
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2673">
              <div className="space-y-2" data-id="element-2674">
                <label className="text-sm font-bold text-gray-700" data-id="element-2675">
                  Plot Number *
                </label>
                <input type="text" required value={formData.plotNumber} onChange={e => setFormData({
                ...formData,
                plotNumber: e.target.value
              })} placeholder="e.g., GOV-2024-001" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2676" />
              </div>
              <div className="space-y-2" data-id="element-2677">
                <label className="text-sm font-bold text-gray-700" data-id="element-2678">
                  Survey Number *
                </label>
                <input type="text" required value={formData.surveyNumber} onChange={e => setFormData({
                ...formData,
                surveyNumber: e.target.value
              })} placeholder="e.g., 45/2/A" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2679" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-id="element-2680">
              <div className="space-y-2" data-id="element-2681">
                <label className="text-sm font-bold text-gray-700" data-id="element-2682">
                  Location *
                </label>
                <input type="text" required value={formData.location} onChange={e => setFormData({
                ...formData,
                location: e.target.value
              })} placeholder="e.g., Hinjewadi Phase 3, Pune" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2683" />
              </div>
              <div className="space-y-2" data-id="element-2684">
                <label className="text-sm font-bold text-gray-700" data-id="element-2685">
                  Total Area (Sq. Ft) *
                </label>
                <input type="number" required value={formData.area} onChange={e => setFormData({
                ...formData,
                area: e.target.value
              })} placeholder="e.g., 5000" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2686" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6" data-id="element-2687">
              <div className="space-y-2" data-id="element-2688">
                <label className="text-sm font-bold text-gray-700" data-id="element-2689">
                  Zoning Classification *
                </label>
                <select required value={formData.zoning} onChange={e => setFormData({
                ...formData,
                zoning: e.target.value
              })} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2690">
                  <option value="" data-id="element-2691">Select Zoning</option>
                  <option value="Residential" data-id="element-2692">Residential</option>
                  <option value="Commercial" data-id="element-2693">Commercial</option>
                  <option value="Industrial" data-id="element-2694">Industrial</option>
                  <option value="Mixed Use" data-id="element-2695">Mixed Use</option>
                  <option value="Agricultural" data-id="element-2696">Agricultural</option>
                </select>
              </div>
              <div className="space-y-2" data-id="element-2697">
                <label className="text-sm font-bold text-gray-700" data-id="element-2698">
                  Base Price (₹ Lakhs) *
                </label>
                <input type="number" required value={formData.basePrice} onChange={e => setFormData({
                ...formData,
                basePrice: e.target.value
              })} placeholder="e.g., 150" className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2699" />
              </div>
            </div>
          </section>

          <section data-id="element-2700">
            <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-2701">
              Description
            </h2>
            <div className="space-y-2" data-id="element-2702">
              <label className="text-sm font-bold text-gray-700" data-id="element-2703">
                Land Parcel Description
              </label>
              <textarea value={formData.description} onChange={e => setFormData({
              ...formData,
              description: e.target.value
            })} placeholder="Describe the land parcel, access roads, utilities, nearby landmarks..." rows={4} className="w-full p-2 border border-gray-300 bg-gray-50 focus:outline-none focus:border-gray-500" data-id="element-2704" />
            </div>
          </section>

          <section data-id="element-2705">
            <h2 className="font-bold text-lg mb-4 pb-2 border-b border-gray-200" data-id="element-2706">
              Documents
            </h2>
            <div className="border-2 border-dashed border-gray-300 p-8 bg-gray-50 text-center" data-id="element-2707">
              <Upload className="w-8 h-8 mx-auto text-gray-400 mb-3" data-id="element-2708" />
              <p className="text-sm font-bold mb-2" data-id="element-2709">Upload Land Documents</p>
              <p className="text-xs text-gray-500 mb-4" data-id="element-2710">
                7/12 Extract, Survey Map, Zoning Certificate (PDF, max 10MB
                each)
              </p>
              <input type="file" multiple accept=".pdf" className="hidden" id="file-upload" data-id="element-2711" />
              <label htmlFor="file-upload" className="inline-block px-6 py-2 bg-white border border-gray-300 text-sm font-bold cursor-pointer hover:bg-gray-50" data-id="element-2712">
                Choose Files
              </label>
            </div>
          </section>

          <div className="pt-6 flex justify-end gap-4 border-t border-gray-200" data-id="element-2713">
            <Link to="/authority/listings" className="px-6 py-2 border border-gray-300 text-sm font-bold hover:bg-gray-50" data-id="element-2714">
              Cancel
            </Link>
            <button type="submit" className="px-6 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2715">
              Create Listing
            </button>
          </div>
        </form>
      </div>

      <MessageModal isOpen={isSuccessModalOpen} onClose={handleModalClose} title="Listing Created" message={`Land parcel ${formData.plotNumber} has been added to public inventory. You can now create an auction for this property.`} type="success" data-id="element-2716" />
    </DashboardLayout>;
}